export const sanitizeCVRNumber = (cvr: string) => {
    if (cvr.match(/^([dD][kK])(?:\d{8})$/) !== null) {
        // remove country code from the CVR
        const regex = /^([dD][kK])/;
        return cvr.replace(regex, '');
    }

    if (cvr.match(/^(\d{8})$/) !== null) return cvr;

    return null;
};
